import styled from "styled-components";
import {
  space,
  color,
  layout,
  flexbox,
  SpaceProps,
  ColorProps,
  LayoutProps,
  FlexboxProps,
  typography,
  TypographyProps,
  position,
  PositionProps,
  ShadowProps,
  shadow,
  BorderProps,
  border,
} from "styled-system";

const Box = styled.div<
  | SpaceProps
  | ColorProps
  | LayoutProps
  | FlexboxProps
  | TypographyProps
  | PositionProps
  | ShadowProps
  | BorderProps
>(
  {
    boxSizing: "border-box",
  },
  space,
  color,
  layout,
  flexbox,
  typography,
  position,
  shadow,
  border
);

export default Box;
